import styled from 'styled-components/macro';
import { Icon } from '~/components';

export const TabIcon = styled(Icon)`
  display: none;
  width: 21px;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: block;
  }
`;

export const CustomNavLink = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-transform: capitalize;
  ${({ color }) =>
    color
      ? `
    color: ${color} !important;
    & svg {
      fill: ${color} !important;
    }
  `
      : null}
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    flex-direction: column;
    font-size: ${({ theme }) => theme.label}px;
  }
`;
